import { PermissionFormData } from "types/permission";

export function convertPermissionData(data: any): PermissionFormData {
    const { name, profile, permissions } = data;
  
    const convertedPermissions = permissions.reduce((acc: Record<string, { create: boolean; read: boolean; list: boolean; update: boolean; delete: boolean, is_active: boolean }>, permission: any) => {
      const moduleName = permission.module.name;
      acc[moduleName] = {
        create: permission.create,
        read: permission.read,
        list: permission.list,
        update: permission.update,
        delete: permission.delete,
        is_active: permission.is_active,
      };
      return acc;
    }, {});
  
    return {
      name,
      profileUuid: profile.uuid,
      groupUuid: profile.group.uuid,
      permissions: convertedPermissions,
    };
  }